// Mock data for Adarsh's Portfolio

import { Twitter } from "lucide-react";

export const personalInfo = {
  name: "Adarsh I Naik",
  title: "BCA Student & Aspiring Developer",
  bio: "Motivated and detail-oriented BCA student with a strong foundation in computer science, programming, and web technologies. Passionate about learning emerging technologies like AI and cloud computing. Eager to apply academic knowledge and technical skills to real-world projects and contribute effectively to team success.",
  email: "adarshnaik276@gmail.com",
  linkedin: "https://www.linkedin.com/in/adarshnaik09",
  github: "https://github.com/Adarshn09",
  leetcode: "https://leetcode.com/adarshnaik276/",
  Twitter:"https://x.com/_adarshnaik09?t=J5N4DSAkUqiu_KR_llDZvg&s=09",
  instagram: "https://www.instagram.com/_adarshnaik09?igsh=MTJ6aW15NXEzeTFwdw==",
  location: "Kumta, Karnataka"
};

export const skills = {
  languages: ["C", "C++", "Java", "Python", "HTML", "CSS", "JavaScript", "R"],
  frameworks: ["Bootstrap"],
  tools: ["Git", "GitHub", "WordPress", "VS Code", "Linux", "Vercel", "Render"],
  databases: ["SQL"]
};

export const projects = [
  {
    id: 1,
    title: "QR Code Generator",
    description: "A web-based application that generates QR codes from text, URLs, or contact information. Features customizable size, color, and download options.",
    technologies: ["HTML", "CSS", "JavaScript", "React", "Express"],
    githubLink: "https://github.com/Adarshn09",
    liveLink: "https://qr-generator-three-silk.vercel.app/",
    featured: true
  },
  {
    id: 2,
    title: "College Event Management System",
    description: "College Event Management System is a web-based application that helps manage college events efficiently.",
    technologies: ["Html", "Css","JavaScript"],
    githubLink: "https://github.com/Adarshn09/CollegeEventFlow.git",
    liveLink: "#",
    featured: false
  },
  {
    id: 3,
    title: "YouTube Video Downloader",
    description: "A powerful, free YouTube video downloader supporting up to 8K resolution with real-time progress tracking and mobile-responsive design.",
    technologies: ["HTML", "CSS", "JavaScript"],
    githubLink: "https://github.com/Adarshn09/Ytdownoders.git",
    liveLink: "#",
    featured: false
  },
  {
    id: 4,
    title: "Personal Portfolio Website",
    description: "Responsive portfolio website showcasing projects, skills, and professional experience with modern design and smooth animations.",
    technologies: ["HTML", "CSS", "JavaScript", "Bootstrap"],
    githubLink: "https://github.com/Adarshn09/portfolio.git",
    liveLink: "https://portfolio-silk-psi-0okpt2j1p2.vercel.app/",
       featured:true
  }
];

export const education = {
  degree: "Bachelor of Computer Applications (BCA)",
  college: "Shree Guru Sudhindra Degree College",
  location: "Bhatkal",
  duration: "2023 - 2026",
  status: "Final Year"
};

// Mock certificates - will be managed via localStorage
export const mockCertificates = [
  {
    id: "cert-1",
    name: "TCS iON Career Edge - IT Prime",
    issuer: "TATA",
    date: "2025-10-13",
    description: "Add your own certificates using the Add Certificate button",
    link: "https://drive.google.com/file/d/1dVm6GfqKVf38Mllc4BYyJq4EOGXwMfud/view?usp=drivesdk"
  },
  {
    id: "cert-2",
    name: "Certified AI Foundations Associate",
    issuer: "Oracle",
    date: "2024-09-07",
    description: "Completed hands-on training in frontend and backend development.",
    link:"https://drive.google.com/file/d/1VMdnUHPYjPkPey9ZVb7TnWPGtYfbuLcN/view?usp=drivesdk"
  },
  {
    id: "cert-3",
    name: "Python Programming",
    issuer: "HackerRank",
    date: "2025-10-19",
    description: "Covered Python fundamentals, OOP, and real-world use cases.",
    link:"https://drive.google.com/file/d/1VMdnUHPYjPkPey9ZVb7TnWPGtYfbuLcN/view?usp=drivesdk"
  }
];

